import { render, staticRenderFns } from "./Agendar.vue?vue&type=template&id=dffdb856&scoped=true"
import script from "./Agendar.vue?vue&type=script&lang=js"
export * from "./Agendar.vue?vue&type=script&lang=js"
import style0 from "./Agendar.vue?vue&type=style&index=0&id=dffdb856&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dffdb856",
  null
  
)

export default component.exports